import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { carecentreTypeScale as type } from "../../typeScale";

const zen = {
  primary: "#0765FF",
  line: "#CAC7BE",
  text: "#15191F",
};

const useStyles = makeStyles(() => ({
  label: {
    margin: 0,
    color: zen.text,
    "& .MuiFormControlLabel-label": {
      fontSize: type.body.fontSize,
      lineHeight: `${type.body.lineHeight}px`,
    },
  },
  switchBase: {
    "&.Mui-checked": {
      color: zen.primary,
      "& + .MuiSwitch-track": {
        backgroundColor: zen.primary,
        opacity: 1,
      },
    },
  },
  track: {
    backgroundColor: zen.line,
    opacity: 1,
  },
}));

const CcSwitch = ({
  label,
  labelPlacement = "end",
  checked,
  onChange,
  disabled = false,
  className,
  ...props
}) => {
  const classes = useStyles();
  const control = (
    <Switch
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      classes={{ switchBase: classes.switchBase, track: classes.track }}
      {...props}
    />
  );

  if (!label) {
    return control;
  }

  return (
    <FormControlLabel
      className={[classes.label, className].filter(Boolean).join(" ")}
      control={control}
      label={label}
      labelPlacement={labelPlacement}
    />
  );
};

export default CcSwitch;
